export const messages = {
  en: {
    ownerExitRoom: {
      ownerInfo: 'Owner Information',
      name: 'Name',
      idCard: 'ID Card',
      phone: 'Phone',
      ownerRoom: 'Owner Rooms',
      room: 'Room',
      builtUpArea: 'Built-up Area',
      squareMeter: 'Square Meter',
      feeInfo: 'Fee Information',
      feeItem: 'Fee Item',
      arrears: 'Arrears',
      startTime: 'Start Time',
      endTime: 'End Time',
      feeStatus: 'Fee Status',
      validate: {
        ownerRequired: 'Owner is required',
        roomRequired: 'Please select at least one room',
        unpaidFee: 'There are unpaid fees, please handle them first'
      }
    },
    selectFeeConfig: {
      title: 'Create Fee',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      amountPlaceholder: 'Required, please enter amount',
      startTimePlaceholder: 'Required, please enter start time',
      endTimePlaceholder: 'Required, please enter end time',
      validate: {
        feeTypeRequired: 'Fee type is required',
        feeItemRequired: 'Fee item is required',
        startTimeRequired: 'Start time is required',
        amountRequired: 'Amount is required'
      }
    }
  },
  zh: {
    ownerExitRoom: {
      ownerInfo: '业主信息',
      name: '姓名',
      idCard: '身份证',
      phone: '手机',
      ownerRoom: '业主房屋',
      room: '房屋',
      builtUpArea: '建筑面积',
      squareMeter: '平方米',
      feeInfo: '费用信息',
      feeItem: '费用项目',
      arrears: '欠费',
      startTime: '开始时间',
      endTime: '结束时间',
      feeStatus: '费用状态',
      validate: {
        ownerRequired: '业主不能为空',
        roomRequired: '请至少选择一间房屋',
        unpaidFee: '房屋还存在费用，请先在业务受理处理费用'
      }
    },
    selectFeeConfig: {
      title: '创建费用',
      feeType: '费用类型',
      feeItem: '收费项目',
      amount: '收费金额',
      startTime: '计费起始时间',
      endTime: '计费结束时间',
      amountPlaceholder: '必填，请填写收费金额',
      startTimePlaceholder: '必填，请填写计费起始时间',
      endTimePlaceholder: '必填，请填写计费结束时间',
      validate: {
        feeTypeRequired: '费用类型不能为空',
        feeItemRequired: '费用项目不能为空',
        startTimeRequired: '计费起始时间不能为空',
amountRequired: '收费金额不能为空'
      }
    }
  },
  'zh-TW': {
    ownerExitRoom: {
      ownerInfo: '業主信息',
      name: '姓名',
      idCard: '身份證',
      phone: '手機',
      ownerRoom: '業主房屋',
      room: '房屋',
      builtUpArea: '建築面積',
      squareMeter: '平方米',
      feeInfo: '費用信息',
      feeItem: '費用項目',
      arrears: '欠費',
      startTime: '開始時間',
      endTime: '結束時間',
      feeStatus: '費用狀態',
      validate: {
        ownerRequired: '業主不能為空',
        roomRequired: '請至少選擇一間房屋',
        unpaidFee: '房屋還存在費用，請先在業務受理處理費用'
      }
    },
    selectFeeConfig: {
      title: '創建費用',
      feeType: '費用類型',
      feeItem: '收費項目',
      amount: '收費金額',
      startTime: '計費起始時間',
      endTime: '計費結束時間',
      amountPlaceholder: '必填，請填寫收費金額',
      startTimePlaceholder: '必填，請填寫計費起始時間',
      endTimePlaceholder: '必填，請填寫計費結束時間',
      validate: {
        feeTypeRequired: '費用類型不能為空',
        feeItemRequired: '收費項目不能為空',
        startTimeRequired: '計費起始時間不能為空',
        amountRequired: '收費金額不能為空'
      }
    }
  }
}